module.exports = __webpack_public_path__ + "static/illustration-9829b4c84837dc56944ff1b1e93da214.png";